import { AxiosRequest } from '@infrastructure/axios';
import { InvoiceProfile, IInvoiceProfile } from '../types';

export default class InvoiceProfileService implements IInvoiceProfile {
  async getInvoiceProfile(controller: AbortController): Promise<InvoiceProfile> {
    const response = await AxiosRequest.get<InvoiceProfile>(`/invoice-profile`, { signal: controller.signal });
    return response.data.data;
  }
}
